class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');

    this.input?.form?.addEventListener("reset", this.onFormReset.bind(this));
    // 180ms keeps the dropdown feeling instant while still collapsing a burst
    // of keystrokes into a single request.
    this.input?.addEventListener(
      "input",
      debounce((event) => {
        this.onChange(event);
      }, 180).bind(this)
    );
  }
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm() && this.input) {
      this.input.value = "";
      this.input.focus();
    }
  }
}

customElements.define("search-form", SearchForm);
